import { createFileRoute } from '@tanstack/react-router';
import { QuizPlayerPage } from '../../../../features/community-hub/components/quiz-player-page';

/**
 * Community Hub - Quiz Player Route
 * Path: /community-hub/quizzes/:id
 *
 * Shows quiz questions and allows user to submit answers
 * Supports multiple question types: multiple choice, multi-select, true/false, short answer, ordering
 */
export const Route = createFileRoute('/_protected/community-hub/quizzes/$id')({
  component: QuizPlayerPage,
});
